import request from '../request'

/**
 * @description  Get patient data
 * @param {*} data
 * @returns
 */
export function uploadWebviewrPatientFileApi(data){
    return request({
        url: 'webviewer/uploadFile',
        method: 'post',
        data,
        timeout: 60 * 60 * 1000,
    })
}

/**
 * @description  Get modal
 * @param {*} data
 * @returns
 */
export function getWebviewrModalApi(data){

    return request({
        url: 'webviewer/getModel',
        method: 'post',
        responseType: 'blob',
        data,
    })
}

/**
 * @description get patients list
 * @param {*} data
 * */
export function getWebviewrPatientsListApi(data){
    return request({
        url: 'webviewer/getPatientsList',
        method: 'get',
        data
    })
}

/**
 * @description  get stage info
 * @param {*} data
 * */
export function getWebviewrStageInfoApi(data){
    return request({
        url: 'webviewer/getStageInfo',
        method: 'post',
        data
    })
}

/**
 * @description  get photos
 * @param {*} data
 * */
export function getPhotosApi(data){
    return request({
        url: 'webviewer/getPhotos',
        method: 'get',
        data
    })
}

/**
 * @description  get setup version list
 * @param {*} data
 * */
export function getSetupVersionListApi(data){
    return request({
        url: 'webviewer/getSetupVersionList',
        method: 'get',
        data
    })
}

/**
 * @description  submit select version
 * @param {*} data
 * */
export function submitSelectVersionApi(data){
    return request({
        url: 'webviewer/submitSelectVersion',
        method: 'post',
        data
    })
}

/**
 * @description  submit user text
 * @param {*} data
 * */
export function submitUserTextApi(data){
    return request({
        url: 'webviewer/submitUserText',
        method: 'post',
        data
    })
}

/**
 * @description  accept setup
 * @param {*} data
 * */
export function acceptSetupApi(data){
    return request({
        url: 'webviewer/acceptSetup',
        method: 'post',
        data
    })
}
